import { combineReducers } from "redux"

import user from "./user"
import event from "./event"
import speaker from "./speaker"
import room from "./room"
import presentation from "./presentation"
import site from "./site"
import schedule from "./schedule"

const reducers = combineReducers({
  user,
  event,
  speaker,
  room,
  presentation,
  site,
  schedule
})

export default reducers
